import book1 from "./assets/book1.jpeg";
import book2 from "./assets/book2.jpeg";
import book3 from "./assets/book3.jpg";
import book4 from "./assets/book4.jpg";

const bookData = [
  {
    id: 1,
    name: "The Outsider",
    picture: book1,
  },
  {
    id: 2,
    name: "the Hobbit",
    picture: book2,
  },
  {
    id: 3,
    name: "Other London",
    picture: book3,
  },
  {
    id: 4,
    name: "The Sum of all Things",
    picture: book4,
  },
];

export default bookData;
